import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-lista',
  templateUrl: './dialog-lista.component.html',
  styleUrls: ['./dialog-lista.component.scss']
})
export class DialogListaComponent {
  public itens_humanas: any[] = [];
  public itens_natureza: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<DialogListaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.itens_humanas = data.data.itens_grupo1;
    this.itens_natureza = data.data.itens_grupo2;
  }
}
